'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

type CookieProps = {
  name: string;
  value: string;
  /** max age in seconds, leave blank for session cookie */
  maxAge?: number;
  domain: string;
};

export function Cookie(props: CookieProps) {
  const router = useRouter();

  useEffect(() => {
    let cookie = `${props.name}=${props.value}; Secure; domain=${props.domain}; path=/;`;

    if (props.maxAge) {
      cookie += `max-age=${props.maxAge};`;
    }

    document.cookie = cookie;

    if (props.name == 'shoppingFor') {
      router.refresh();
    }
  }, [props.domain, props.maxAge, props.name, props.value, router]);

  return null;
}
